
export const IS_BLOCKING_INFOCHANNEL = 'IS_BLOCKING_INFOCHANNEL';
export const PATH_NAME_INFOCHANNEL = 'PATH_NAME_INFOCHANNEL';


export const isBlockingInfoChannel = (isblockinginfochannel) => ({
    type: IS_BLOCKING_INFOCHANNEL,
    payload: isblockinginfochannel ,
});
export const pathNameInfoChannel = (pathnameinfochannel) => ({
    type: PATH_NAME_INFOCHANNEL,
    payload: pathnameinfochannel ,
});

